import { useEffect, useState } from "react"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { LgFileInputV2, LgFormInput } from "../../components/Form/FormInput"
import { Text } from "../../components/units/Text"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../interfaces/Rest/types"
import { AcbOsPostProps, AcbOsProps } from "../../components/Rest/RestAcbOs"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { useRequiredSerialNumber } from "./useRequiredSerialNumber"

interface FirmwareFormState {
    data: AcbOsProps | null
    newFile?: File
    requestState: RestApiState
    timeOutId: NodeJS.Timeout | null
}

const defaultState: FirmwareFormState = {
    data: null,
    newFile: undefined,
    requestState: RestApiState.Idle,
    timeOutId: null,
}

interface FirmwareUpdateFormProps {
    title: string
    versionLabel: string
    version?: string
    fileInputId: string
    maxFileSize: number
    fetchOsData: (serialNumber: string, role: string, setData: (value: any) => void) => void
    updateOsData: (serialNumber: string, role: string, data: AcbOsPostProps, statusSetter: (value: RestApiState) => void) => void
}

export const FirmwareUpdateForm = ({
    title,
    versionLabel,
    version,
    fileInputId,
    maxFileSize,
    fetchOsData,
    updateOsData,
}: FirmwareUpdateFormProps): JSX.Element => {
    const { user } = useSignedInContext()
    const serialNumber = useRequiredSerialNumber()
    const [formState, setFormState] = useState<FirmwareFormState>(defaultState)

    useEffect(() => {
        fetchOsData(serialNumber, user.role_slug, (value: any) => {
            setFormState((prev) => ({
                ...prev,
                data: value,
            }))
        })
    }, [])

    const restStatusSetter = (value: RestApiState) => {
        setFormState((prev) => ({
            ...prev,
            requestState: value,
        }))
    }

    const fileChangeHandler = (e: any): void => {
        let file = e.target.files[0]
        let success = true

        if (file) {
            if (file.size > maxFileSize) {
                alert(`Допустимый размер менее ${maxFileSize}KB. ${file.size}`)
                success = false
            }

            if (!success) {
                alert("Файл не соотвтесвует требованиям")
                file = undefined
            }

            setFormState((prev) => ({
                ...prev,
                newFile: file,
            }))
        }
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()
        if (formState.newFile === undefined) {
            throw new Error("File cant be empty")
        }
        restStatusSetter(RestApiState.Pending)
        updateOsData(serialNumber, user.role_slug, { file: formState.newFile }, restStatusSetter)
    }

    return (
        <BoxWrapper bg="bg-primary" r="r10" p="p4" className="relative flex-grow standart-border" style={{ minWidth: "400px" }}>
            <Text size="xl" className="bold">{title}</Text>
            <br />
            <form onSubmit={handleSubmit}>
                <FlexWrapper flexDirection="column" alignItems="start">
                    <LgFormInput
                        value={version ? version : "Нет данных"}
                        label={versionLabel}
                        name="file_hash"
                        type="text"
                        required={false}
                        valueSetter={() => {}}
                        disabled={true}
                        className="flex-grow"
                    />
                    <LgFileInputV2
                        id={fileInputId}
                        value={formState.newFile}
                        label="Название файла"
                        name="file_name"
                        required={false}
                        valueSetter={fileChangeHandler}
                        serverFile={formState.data?.file_name ? formState.data.file_name : ""}
                    />
                    <SubmitButton
                        restState={formState.requestState}
                        disabled={formState.newFile === undefined}
                        restHandler={{
                            timeOutId: formState.timeOutId,
                            setter: (key: "requestState" | "timeOutId", value: any) => {
                                setFormState((prev) => ({
                                    ...prev,
                                    [key]: value,
                                }))
                            },
                        }}
                    />
                </FlexWrapper>
            </form>
        </BoxWrapper>
    )
}
